import { useCallback } from 'react';

interface ExportOptions {
  title: string;
}

export function usePdfExport({ title }: ExportOptions) {
  const exportToPdf = useCallback(() => {
    const originalTitle = document.title;
    document.title = title;
    window.print();
    document.title = originalTitle;
  }, [title]);

  return { exportToPdf };
}
